export function getSiteUrl(): string {
  return import.meta.env.VITE_SITE_URL || 'https://basetaosheet.pics';
}